import React from 'react';
// Components
import ManageProductsTable from 'components/common/ManageProductsTable';

const ManageOrganizationProducts: React.FC = () => {
  return <ManageProductsTable />;
};

export default ManageOrganizationProducts;
